import RappidContext from './rappid-context'

export default class PanController {
  constructor(private context: RappidContext) {}

  activate(): void {
    this.activateSelection()
  }

  activateSelection(): void {
    this.context.paper.on(
      'blank:pointerdown',
      (evt: joint.dia.Event /*, x: number, y: number */) => {
        this.context.paperScroller.startPanning(evt)
        //this.context.paper.removeTools()
      },
    )
  }
}
